import { ColumnDef } from "@tanstack/react-table";
import { GenericCheckbox } from "../GenericCheckbox";

export const TableSelectColumn = <
  TData extends object
>(): ColumnDef<TData> => ({
  id: "select",
  header: ({ table }) => (
    <GenericCheckbox
      checked={table.getIsAllRowsSelected()}
      onChange={table.getToggleAllRowsSelectedHandler()}
    />
  ),
  cell: ({ row }) => (
    <GenericCheckbox
      checked={row.getIsSelected()}
      onChange={row.getToggleSelectedHandler()}
    />
  ),
  enableSorting: false,
  enableColumnFilter: false,
});
